import { useNavigate } from 'react-router-dom';
import Card from '../components/card/Card';
import H from '../components/texts/h/H';
import Button from '../components/button/Button';
import Icon from '../components/icon/Icon';
import { routes } from '../routes/routePaths';

const config = JSON.parse(localStorage.getItem('config') ?? '{}');
const isGuaranteesEnabled = config?.isGuaranteesEnabled ?? false;
const isQuotationsEnabled = config?.isQuotationsEnabled ?? false;

const Settings = () => {
  const navigate = useNavigate();

  const handleModifyRates = () => {
    navigate(routes.rateTypes);
  };

  const handleCompanyData = () => {
    navigate(routes.sgr);
  };

  const handlePartners = () => {
    navigate(routes.partners);
  };

  const handleFunds = () => {
    navigate(routes.funds);
  };

  const handleAssetsToIntegrate = () => {
    navigate(routes.assetsToIntegrate);
  };

  const handleQuotations = () => {
    navigate(routes.quotations);
  };

  return (
    <Card variant='neutral' modifier='inverted' spacing='4' height='-webkit-fill-available' width='85vw'>
      <Card display='flex' justifyContent='space-between' alignItems='center' margin={{ bottom: '3' }}>
        <H withMargin={false} type='1' weight='bold' modifier='strong'>
          Configuración
        </H>
      </Card>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {isGuaranteesEnabled && (
          <div style={{ border: '1px solid #DFE6EB', borderRadius: '8px', padding: '16px' }}>
            <Card 
              display='flex' 
              justifyContent='space-between' 
              alignItems='center'
            >
              <H withMargin={false} variant="secondary-2" type='2' weight='bold' modifier='strong'>
                Modificar tipo de tasas
              </H>
              
              <Button
                variant="primary"
                size='lg'
                onClick={handleModifyRates}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Icon name='settings_outline' width={20} height={20} variant='neutral' modifier='inverted' />
                  Configurar
                </div>
              </Button>
            </Card>
          </div>
        )}

        {isGuaranteesEnabled && (
          <div style={{ border: '1px solid #DFE6EB', borderRadius: '8px', padding: '16px' }}>
            <Card 
              display='flex' 
              justifyContent='space-between' 
              alignItems='center'
            >
              <Card display='flex' alignItems='center' gap='8px'>
                <Icon name='company' width={24} height={24} variant='secondary-2' />
                <H withMargin={false} variant="secondary-2" type='2' weight='bold' modifier='strong'>
                  Mis datos de empresa
                </H>
              </Card>
              
              <Button
                variant="primary"
                size='lg'
                onClick={handleCompanyData}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Icon name='settings_outline' width={20} height={20} variant='neutral' modifier='inverted' />
                  Configurar
                </div>
              </Button>
            </Card>
          </div>
        )}

        {isGuaranteesEnabled && (
          <div style={{ border: '1px solid #DFE6EB', borderRadius: '8px', padding: '16px' }}>
            <Card 
              display='flex' 
              justifyContent='space-between' 
              alignItems='center'
            >
              <H withMargin={false} variant="secondary-2" type='2' weight='bold' modifier='strong'>
                Socios
              </H>
              
              <Button
                variant="primary"
                size='lg'
                onClick={handlePartners}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Icon name='settings_outline' width={20} height={20} variant='neutral' modifier='inverted' />
                  Configurar
                </div>
              </Button>
            </Card>
          </div>
        )}

        {isGuaranteesEnabled && (
          <div style={{ border: '1px solid #DFE6EB', borderRadius: '8px', padding: '16px' }}>
            <Card 
              display='flex' 
              justifyContent='space-between' 
              alignItems='center'
            >
              <H withMargin={false} variant="secondary-2" type='2' weight='bold' modifier='strong'>
                Fondos
              </H>
              
              <Button
                variant="primary"
                size='lg'
                onClick={handleFunds}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Icon name='settings_outline' width={20} height={20} variant='neutral' modifier='inverted' />
                  Configurar
                </div>
              </Button>
            </Card>
          </div>
        )}

        {isGuaranteesEnabled && (
          <div style={{ border: '1px solid #DFE6EB', borderRadius: '8px', padding: '16px' }}>
            <Card 
              display='flex' 
              justifyContent='space-between' 
              alignItems='center'
            >
              <H withMargin={false} variant="secondary-2" type='2' weight='bold' modifier='strong'>
                Activos a integrar
              </H>
              
              <Button
                variant="primary"
                size='lg'
                onClick={handleAssetsToIntegrate}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Icon name='settings_outline' width={20} height={20} variant='neutral' modifier='inverted' />
                  Configurar
                </div>
              </Button>
            </Card>
          </div>
        )}
        {(isGuaranteesEnabled || isQuotationsEnabled) && (
        <div style={{ border: '1px solid #DFE6EB', borderRadius: '8px', padding: '16px' }}>
          <Card 
            display='flex' 
            justifyContent='space-between' 
            alignItems='center'
          >
            <H withMargin={false} variant="secondary-2" type='2' weight='bold' modifier='strong'>
              Activos a cotizar
            </H>
            
            <Button
              variant="primary"
              size='lg'
              onClick={handleQuotations}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Icon name='settings_outline' width={20} height={20} variant='neutral' modifier='inverted' />
                Configurar
              </div>
            </Button>
          </Card>
        </div>
        )}
      </div>
    </Card>
  );
};

export default Settings;